/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SliderOutputDto } from '../model/sliderOutputDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
    providedIn:'root'
})
export class SliderService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdslider 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSliderDeleteDelete(cdslider?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiSliderDeleteDelete(cdslider?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiSliderDeleteDelete(cdslider?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiSliderDeleteDelete(cdslider?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdslider !== undefined && cdslider !== null) {
            queryParameters = queryParameters.set('cdslider', <any>cdslider);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/api/Slider/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdSlider 
     * @param dsTitle 
     * @param nmSortNo 
     * @param image 
     * @param dsNewImg 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSliderEditPutForm(cdSlider?: number, dsTitle?: string, nmSortNo?: number, image?: Blob, dsNewImg?: string, observe?: 'body', reportProgress?: boolean): Observable<SliderOutputDto>;
    public apiSliderEditPutForm(cdSlider?: number, dsTitle?: string, nmSortNo?: number, image?: Blob, dsNewImg?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SliderOutputDto>>;
    public apiSliderEditPutForm(cdSlider?: number, dsTitle?: string, nmSortNo?: number, image?: Blob, dsNewImg?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SliderOutputDto>>;
    public apiSliderEditPutForm(cdSlider?: number, dsTitle?: string, nmSortNo?: number, image?: Blob, dsNewImg?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdSlider !== undefined) {
            formParams = formParams.append('CdSlider', <any>cdSlider) as any || formParams;
        }
        if (dsTitle !== undefined) {
            formParams = formParams.append('DsTitle', <any>dsTitle) as any || formParams;
        }
        if (nmSortNo !== undefined) {
            formParams = formParams.append('NmSortNo', <any>nmSortNo) as any || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) as any || formParams;
        }
        if (dsNewImg !== undefined) {
            formParams = formParams.append('DsNewImg', <any>dsNewImg) as any || formParams;
        }

        return this.httpClient.request<SliderOutputDto>('put',`${this.basePath}/api/Slider/Edit`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSliderGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<SliderOutputDto>>;
    public apiSliderGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SliderOutputDto>>>;
    public apiSliderGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SliderOutputDto>>>;
    public apiSliderGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SliderOutputDto>>('get',`${this.basePath}/api/Slider/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdslider 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSliderGetOneGet(cdslider?: number, observe?: 'body', reportProgress?: boolean): Observable<SliderOutputDto>;
    public apiSliderGetOneGet(cdslider?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SliderOutputDto>>;
    public apiSliderGetOneGet(cdslider?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SliderOutputDto>>;
    public apiSliderGetOneGet(cdslider?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdslider !== undefined && cdslider !== null) {
            queryParameters = queryParameters.set('cdslider', <any>cdslider);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SliderOutputDto>('get',`${this.basePath}/api/Slider/GetOne`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param dsTitle 
     * @param dsImg 
     * @param nmSortNo 
     * @param image 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSliderPostPostForm(dsTitle?: string, dsImg?: string, nmSortNo?: number, image?: Blob, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiSliderPostPostForm(dsTitle?: string, dsImg?: string, nmSortNo?: number, image?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiSliderPostPostForm(dsTitle?: string, dsImg?: string, nmSortNo?: number, image?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiSliderPostPostForm(dsTitle?: string, dsImg?: string, nmSortNo?: number, image?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (dsTitle !== undefined) {
            formParams = formParams.append('DsTitle', <any>dsTitle) as any || formParams;
        }
        if (dsImg !== undefined) {
            formParams = formParams.append('DsImg', <any>dsImg) as any || formParams;
        }
        if (nmSortNo !== undefined) {
            formParams = formParams.append('NmSortNo', <any>nmSortNo) as any || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) as any || formParams;
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/Slider/Post`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
